
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { FaArrowRight } from 'react-icons/fa';
import './CTA.css';

const CTA = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="cta-premium-wrapper" ref={ref}>
      <div className="container">
        <motion.div
          className="cta-statement-box"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={isVisible ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <div className="cta-accent-line"></div>

          <div className="cta-inner-content">
            <h2 className="cta-headline">Transformation begins with clarity</h2>

            <p className="cta-lead-text">
              Before scaling further, it’s worth pausing to understand what truly needs alignment.
            </p>

            <p className="cta-body-description">
              We invite you to start with a <strong>diagnostic conversation</strong>, not a sales pitch but a thoughtful discussion on your organization’s direction, systems, and execution challenges.
            </p>

            <div className="cta-action-area">
              <Link to="/contact" className="cta-primary-button">
                Get in Touch
                <FaArrowRight className="cta-btn-icon" />
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;
